import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const activeInstallationProcessUseCase = async () => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;
    const source_id = state.yourSlice.connectionView?.source?.source_id;
    const response = await apiUseCases.activeInstallationProcess(
      namespace,
      source_id,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to fetch the active installation process",
      ).message,
    };
  }
};
